import { Box, Button, Typography } from "@mui/material";
import React from "react";

interface BlogNoPostsProps {
  searchQuery: string;
  clearSearch: () => void;
}

const BlogNoPosts: React.FC<BlogNoPostsProps> = ({
  searchQuery,
  clearSearch,
}) => {
  return (
    <Box sx={{ textAlign: "center", py: 8 }}>
      <Typography
        variant="h6"
        sx={{ color: "#1e293b", mb: 2, fontSize: { xs: 16, md: 18 } }}
      >
        {searchQuery.length >= 3
          ? "No articles found for your search."
          : "No articles found."}
      </Typography>
      {searchQuery.length >= 3 && (
        <Button onClick={clearSearch} variant="outlined" color="primary">
          Clear search and browse all articles
        </Button>
      )}
    </Box>
  );
};

export default BlogNoPosts;
